var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ChildProperty, Property, Complex } from '@syncfusion/ej2-base';
import { Point } from '@syncfusion/ej2-drawings';
import { Size } from '@syncfusion/ej2-drawings';
/**
 * The `PdfBounds` is base for annotation bounds.
 *
 * @hidden
 */
export class PdfBounds extends ChildProperty {
}
__decorate([
    Property(0)
], PdfBounds.prototype, "x", void 0);
__decorate([
    Property(0)
], PdfBounds.prototype, "y", void 0);
__decorate([
    Property(0)
], PdfBounds.prototype, "width", void 0);
__decorate([
    Property(0)
], PdfBounds.prototype, "height", void 0);
__decorate([
    Property(0)
], PdfBounds.prototype, "left", void 0);
__decorate([
    Property(0)
], PdfBounds.prototype, "top", void 0);
__decorate([
    Property(0)
], PdfBounds.prototype, "right", void 0);
__decorate([
    Property(0)
], PdfBounds.prototype, "bottom", void 0);
__decorate([
    Complex({ x: 0, y: 0 }, Point)
], PdfBounds.prototype, "location", void 0);
__decorate([
    Complex(new Size(0, 0), Size)
], PdfBounds.prototype, "size", void 0);
/**
 * The `PdfFont` is base for annotation Text styles.
 *
 * @hidden
 */
export class PdfFont extends ChildProperty {
}
__decorate([
    Property(false)
], PdfFont.prototype, "isBold", void 0);
__decorate([
    Property(false)
], PdfFont.prototype, "isItalic", void 0);
__decorate([
    Property(false)
], PdfFont.prototype, "isUnderline", void 0);
__decorate([
    Property(false)
], PdfFont.prototype, "isStrikeout", void 0);
/**
 * Defines the common behavior of PdfAnnotationBase
 *
 * @hidden
 */
export class PdfAnnotationBase extends ChildProperty {
    constructor(parent, propName, defaultValue, isArray) {
        super(parent, propName, defaultValue, isArray);
    }
}
__decorate([
    Property('')
], PdfAnnotationBase.prototype, "id", void 0);
__decorate([
    Property('Rectangle')
], PdfAnnotationBase.prototype, "shapeAnnotationType", void 0);
__decorate([
    Property(null)
], PdfAnnotationBase.prototype, "formFieldAnnotationType", void 0);
__decorate([
    Property('')
], PdfAnnotationBase.prototype, "measureType", void 0);
__decorate([
    Property('')
], PdfAnnotationBase.prototype, "author", void 0);
__decorate([
    Property('')
], PdfAnnotationBase.prototype, "modifiedDate", void 0);
__decorate([
    Property('')
], PdfAnnotationBase.prototype, "subject", void 0);
__decorate([
    Property('')
], PdfAnnotationBase.prototype, "notes", void 0);
__decorate([
    Property(false)
], PdfAnnotationBase.prototype, "isCommentLock", void 0);
__decorate([
    Property('black')
], PdfAnnotationBase.prototype, "strokeColor", void 0);
__decorate([
    Property('#ffffff00')
], PdfAnnotationBase.prototype, "fillColor", void 0);
__decorate([
    Property('#ffffff00')
], PdfAnnotationBase.prototype, "stampFillColor", void 0);
__decorate([
    Property('black')
], PdfAnnotationBase.prototype, "stampStrokeColor", void 0);
__decorate([
    Property('')
], PdfAnnotationBase.prototype, "data", void 0);
__decorate([
    Property(1)
], PdfAnnotationBase.prototype, "opacity", void 0);
__decorate([
    Property(1)
], PdfAnnotationBase.prototype, "thickness", void 0);
__decorate([
    Property('')
], PdfAnnotationBase.prototype, "borderStyle", void 0);
__decorate([
    Property('')
], PdfAnnotationBase.prototype, "borderDashArray", void 0);
__decorate([
    Property(0)
], PdfAnnotationBase.prototype, "rotateAngle", void 0);
__decorate([
    Property(false)
], PdfAnnotationBase.prototype, "isCloudShape", void 0);
__decorate([
    Property(0)
], PdfAnnotationBase.prototype, "cloudIntensity", void 0);
__decorate([
    Property(40)
], PdfAnnotationBase.prototype, "leaderHeight", void 0);
__decorate([
    Property(null)
], PdfAnnotationBase.prototype, "lineHeadStart", void 0);
__decorate([
    Property(null)
], PdfAnnotationBase.prototype, "lineHeadEnd", void 0);
__decorate([
    Property([])
], PdfAnnotationBase.prototype, "vertexPoints", void 0);
__decorate([
    Property(null)
], PdfAnnotationBase.prototype, "sourcePoint", void 0);
__decorate([
    Property('None')
], PdfAnnotationBase.prototype, "sourceDecoraterShapes", void 0);
__decorate([
    Property('None')
], PdfAnnotationBase.prototype, "taregetDecoraterShapes", void 0);
__decorate([
    Property(null)
], PdfAnnotationBase.prototype, "targetPoint", void 0);
__decorate([
    Property([])
], PdfAnnotationBase.prototype, "segments", void 0);
__decorate([
    Complex({ x: 0, y: 0 }, PdfBounds)
], PdfAnnotationBase.prototype, "bounds", void 0);
__decorate([
    Property(0)
], PdfAnnotationBase.prototype, "pageIndex", void 0);
__decorate([
    Property(-1)
], PdfAnnotationBase.prototype, "zIndex", void 0);
__decorate([
    Property(null)
], PdfAnnotationBase.prototype, "wrapper", void 0);
__decorate([
    Property(false)
], PdfAnnotationBase.prototype, "isDynamicStamp", void 0);
__decorate([
    Property('')
], PdfAnnotationBase.prototype, "dynamicText", void 0);
__decorate([
    Property('')
], PdfAnnotationBase.prototype, "annotName", void 0);
__decorate([
    Property({})
], PdfAnnotationBase.prototype, "review", void 0);
__decorate([
    Property([])
], PdfAnnotationBase.prototype, "comments", void 0);
__decorate([
    Property('#000')
], PdfAnnotationBase.prototype, "fontColor", void 0);
__decorate([
    Property(16)
], PdfAnnotationBase.prototype, "fontSize", void 0);
__decorate([
    Property('Helvetica')
], PdfAnnotationBase.prototype, "fontFamily", void 0);
__decorate([
    Property('None')
], PdfAnnotationBase.prototype, "fontStyle", void 0);
__decorate([
    Property(false)
], PdfAnnotationBase.prototype, "enableShapeLabel", void 0);
__decorate([
    Property('label')
], PdfAnnotationBase.prototype, "labelContent", void 0);
__decorate([
    Property('#ffffff00')
], PdfAnnotationBase.prototype, "labelFillColor", void 0);
__decorate([
    Property(15)
], PdfAnnotationBase.prototype, "labelMaxLength", void 0);
__decorate([
    Property('')
], PdfAnnotationBase.prototype, "template", void 0);
__decorate([
    Property('')
], PdfAnnotationBase.prototype, "templateSize", void 0);
__decorate([
    Property(1)
], PdfAnnotationBase.prototype, "labelOpacity", void 0);
__decorate([
    Property('')
], PdfAnnotationBase.prototype, "annotationSelectorSettings", void 0);
__decorate([
    Property('#ffffff00')
], PdfAnnotationBase.prototype, "labelBorderColor", void 0);
__decorate([
    Property('left')
], PdfAnnotationBase.prototype, "textAlign", void 0);
__decorate([
    Property('')
], PdfAnnotationBase.prototype, "signatureName", void 0);
__decorate([
    Property(0)
], PdfAnnotationBase.prototype, "minHeight", void 0);
__decorate([
    Property(0)
], PdfAnnotationBase.prototype, "minWidth", void 0);
__decorate([
    Property(0)
], PdfAnnotationBase.prototype, "maxHeight", void 0);
__decorate([
    Property(0)
], PdfAnnotationBase.prototype, "maxWidth", void 0);
__decorate([
    Property(false)
], PdfAnnotationBase.prototype, "isLock", void 0);
__decorate([
    Property('UI Drawn Annotation')
], PdfAnnotationBase.prototype, "annotationAddMode", void 0);
__decorate([
    Property('')
], PdfAnnotationBase.prototype, "annotationSettings", void 0);
__decorate([
    Property(16)
], PdfAnnotationBase.prototype, "previousFontSize", void 0);
__decorate([
    Complex({ isBold: false, isItalic: false, isStrikeout: false, isUnderline: false }, PdfFont)
], PdfAnnotationBase.prototype, "font", void 0);
__decorate([
    Complex({ x: 0, y: 0 }, PdfBounds)
], PdfAnnotationBase.prototype, "labelBounds", void 0);
__decorate([
    Property(null)
], PdfAnnotationBase.prototype, "customData", void 0);
__decorate([
    Property(['None'])
], PdfAnnotationBase.prototype, "allowedInteractions", void 0);
__decorate([
    Property(true)
], PdfAnnotationBase.prototype, "isPrint", void 0);
__decorate([
    Property(false)
], PdfAnnotationBase.prototype, "isReadonly", void 0);
__decorate([
    Property(0)
], PdfAnnotationBase.prototype, "pageRotation", void 0);
__decorate([
    Property('')
], PdfAnnotationBase.prototype, "icon", void 0);
__decorate([
    Property(false)
], PdfAnnotationBase.prototype, "isAddAnnotationProgrammatically", void 0);
__decorate([
    Property(false)
], PdfAnnotationBase.prototype, "isTransparentSet", void 0);
/**
 * Defines the common behavior of PdfFormFieldBase
 *
 * @hidden
 */
export class PdfFormFieldBase extends ChildProperty {
    constructor(parent, propName, defaultValue, isArray) {
        super(parent, propName, defaultValue, isArray);
    }
}
__decorate([
    Property('')
], PdfFormFieldBase.prototype, "id", void 0);
__decorate([
    Property('')
], PdfFormFieldBase.prototype, "signatureType", void 0);
__decorate([
    Property('')
], PdfFormFieldBase.prototype, "name", void 0);
__decorate([
    Property('')
], PdfFormFieldBase.prototype, "value", void 0);
__decorate([
    Property(null)
], PdfFormFieldBase.prototype, "formFieldAnnotationType", void 0);
__decorate([
    Property('#daeaf7ff')
], PdfFormFieldBase.prototype, "backgroundColor", void 0);
__decorate([
    Property('black')
], PdfFormFieldBase.prototype, "color", void 0);
__decorate([
    Property('#303030')
], PdfFormFieldBase.prototype, "borderColor", void 0);
__decorate([
    Property('')
], PdfFormFieldBase.prototype, "tooltip", void 0);
__decorate([
    Property(1)
], PdfFormFieldBase.prototype, "opacity", void 0);
__decorate([
    Property(1)
], PdfFormFieldBase.prototype, "thickness", void 0);
__decorate([
    Property(0)
], PdfFormFieldBase.prototype, "rotateAngle", void 0);
__decorate([
    Complex({ x: 0, y: 0 }, PdfBounds)
], PdfFormFieldBase.prototype, "bounds", void 0);
__decorate([
    Property(0)
], PdfFormFieldBase.prototype, "pageIndex", void 0);
__decorate([
    Property(1)
], PdfFormFieldBase.prototype, "pageNumber", void 0);
__decorate([
    Property(-1)
], PdfFormFieldBase.prototype, "zIndex", void 0);
__decorate([
    Property(null)
], PdfFormFieldBase.prototype, "wrapper", void 0);
__decorate([
    Property(16)
], PdfFormFieldBase.prototype, "fontSize", void 0);
__decorate([
    Property('Helvetica')
], PdfFormFieldBase.prototype, "fontFamily", void 0);
__decorate([
    Property('None')
], PdfFormFieldBase.prototype, "fontStyle", void 0);
__decorate([
    Property('left')
], PdfFormFieldBase.prototype, "alignment", void 0);
__decorate([
    Property(0)
], PdfFormFieldBase.prototype, "minHeight", void 0);
__decorate([
    Property(0)
], PdfFormFieldBase.prototype, "minWidth", void 0);
__decorate([
    Property(0)
], PdfFormFieldBase.prototype, "maxHeight", void 0);
__decorate([
    Property(0)
], PdfFormFieldBase.prototype, "maxWidth", void 0);
__decorate([
    Property(0)
], PdfFormFieldBase.prototype, "maxLength", void 0);
__decorate([
    Property('visible')
], PdfFormFieldBase.prototype, "visibility", void 0);
__decorate([
    Property(true)
], PdfFormFieldBase.prototype, "isPrint", void 0);
__decorate([
    Property(false)
], PdfFormFieldBase.prototype, "isReadonly", void 0);
__decorate([
    Property(false)
], PdfFormFieldBase.prototype, "isChecked", void 0);
__decorate([
    Property(false)
], PdfFormFieldBase.prototype, "isSelected", void 0);
__decorate([
    Property(false)
], PdfFormFieldBase.prototype, "isRequired", void 0);
__decorate([
    Property(false)
], PdfFormFieldBase.prototype, "isMultiline", void 0);
__decorate([
    Property(false)
], PdfFormFieldBase.prototype, "isTransparent", void 0);
__decorate([
    Property(false)
], PdfFormFieldBase.prototype, "insertSpaces", void 0);
__decorate([
    Property('')
], PdfFormFieldBase.prototype, "options", void 0);
__decorate([
    Property()
], PdfFormFieldBase.prototype, "signatureIndicatorSettings", void 0);
__decorate([
    Complex({ isBold: false, isItalic: false, isStrikeout: false, isUnderline: false }, PdfFont)
], PdfFormFieldBase.prototype, "font", void 0);
__decorate([
    Property()
], PdfFormFieldBase.prototype, "selectedIndex", void 0);
__decorate([
    Property(null)
], PdfFormFieldBase.prototype, "customData", void 0);
/**
 * @hidden
 */
export class ZOrderPageTable {
    constructor() {
        this.pageIdTemp = 0;
        this.zIndexTemp = -1;
        this.childNodesTemp = [];
        this.objects = [];
        this.zIndexTemp = -1;
        this.pageIdTemp = 0;
    }
    /**
     * @private
     * @returns {number} - Returns the page Id.
     */
    get pageId() {
        return this.pageIdTemp;
    }
    /**
     * @private
     * @param {number} offset - The page offset value.
     */
    set pageId(offset) {
        this.pageIdTemp = offset;
    }
    /**
     * @private
     * @returns {number} - Returns the z-index value.
     */
    get zIndex() {
        return this.zIndexTemp;
    }
    /**
     * @private
     * @param {number} offset - The page offset value.
     */
    set zIndex(offset) {
        this.zIndexTemp = offset;
    }
    /**
     * @private
     * @returns {PdfAnnotationBaseModel[]} - Returns the annotation childNodes.
     */
    get objects() {
        return this.childNodesTemp;
    }
    /**
     * @private
     * @param {PdfAnnotationBaseModel[]} childNodes - Specified the annotation child nodes.
     */
    set objects(childNodes) {
        this.childNodesTemp = childNodes;
    }
}
